import { useQuery } from "react-query";
import { Company } from "../models";
import { ICompany } from "../types";
import { useCache } from "../context/CacheContext";
import { useWorkspace } from "../context/WorkspaceContext";
import { useUserSession } from "../context/UserContext";
import { listCompanies } from "../data/api/companies";
import { queryKeys } from "../data/queryKeys";

/**
 * Workspace companies, read through the REST API (previously a direct Firestore
 * query). Query key, cache-key invalidation and `Company[]` instance return
 * shape are preserved.
 */
const useCompanies = (workspaceId?: string) => {
  const { cacheKey } = useCache();
  const { activeWorkspace } = useWorkspace();
  const { userSession, isAuthenticated } = useUserSession();
  const resolvedWorkspaceId = workspaceId ?? activeWorkspace?.workspaceId ?? "";
  const token = userSession?.token?.accessToken;

  return useQuery<Company[], Error>(
    queryKeys.companies(cacheKey, resolvedWorkspaceId),
    async () => {
      const companies = await listCompanies(token as string, resolvedWorkspaceId);
      return companies.map((company: ICompany) => new Company(company));
    },
    {
      enabled: !!token && !!resolvedWorkspaceId && isAuthenticated(),
    },
  );
};

export default useCompanies;
